import {AppConfig} from "../../../assets/config/app-config";
import {InjectionToken} from "@angular/core";

export interface IAppConfig {
    env: {
        name: string;
    };
    logging: {
        console: boolean;
        appInsights: boolean;
        level: string;
    };
    api: {
        url: string;
    };
    azure: {
        b2c: {
            instance: string;
            domain: string;
            clientId: string;
            signedOutCallbackPath: string;
            signUpSignInPolicyId: string;
            redirectUri: string;
            scopes: string[];
        };
    };
}
export let APP_CONFIG_TOKEN = new InjectionToken<AppConfig>('APP_CONFIG');

